import { BasicLayout, RouteView } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/login/Auth')
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('../epp/Index')
  },
   {
        path: '/SupplierIndex',
        name: 'SupplierIndex',
        component: () => import('../epp/SupplierIndex'),
   },
    {
        path: '/Demo',
        name: 'Demo',
        component: () => import('@/epp/example/Demo')
    },
    {
        path: '/SignIndex',
        name: 'SignIndex',
        component: () => import('../epp/sign/SignIndex'),
    },
  {
    path: '/',
    redirect: '/auth',
    name: '首页',
    hidden: true
  }
]


export function generateModuleRoute () {
  return asyncRouterMapBak
}

export const asyncRouterMapBak = [
  {
    path: '/',
    component: BasicLayout,
    name: 'index',
    meta: { title: '首页' },
    redirect: '/dashboard/workplace',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { title: '仪表盘', icon: 'dashboard' },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/views/dashboard/Workplace'),
            meta: { title: '工作台' }
          }
        ]
      },
      {
        path: '/my-project',
        component: RouteView,
        name: 'MyProject',
        redirect: '/my-project/index',
        meta: { title: '我的项目', icon: 'table' },
        children: [
          {
            path: '/my-project/index',
            name: 'MyProjectIndex',
            component: () => import('@/epp/examples/Example'),
            meta: { title: '进行中' }
          }
        ]
      }
    ]
  },
    {
        path: '/compete/competitive',
        name: 'NewSingleCompete',
        component: () => import('@/epp/compete/NewCompeteIndex')
    },
    {
        path: '/compete/PacksList',
        name: 'PacksList',
        component: () => import('@/epp/compete/PacksList')
    },
    {
        path: '/legal/PacksList',
        name: 'LegalPacksList',
        component: () => import('@/epp/legal/PacksList')
    },
    {
        path: '/demand/demandList',
        name: 'demandList',
        component: () => import('@/epp/demand/DemandList')
    },
    {
        path: '/announce/AnnounceIndex',
        name: 'AnnounceIndex',
        component: () => import('@/epp/announce/AnnounceIndex')
    },
  {
    path: '/project/announce',
    name: 'Sign',
    component: () => import('@/epp/announce/ProjectAnnounce')
  },
    {
        path: '/demand/announce',
        name: 'demand',
        component: () => import('@/epp/announce/DemandProjectAnnounce')
    },
  {
    path: '/project/InviteDetails',
    name: 'InviteDetails',
    component: () => import('@/epp/project/InviteDetails')
  },
  {
    path: '/project/InviteLegalDetails',
    name: 'InviteLegalDetails',
    component: () => import('@/epp/project/InviteLegalDetails')
  },
    {
        path: '/ZgYsFile',
        name: 'ZgYsFile',
        component: () => import('../epp/legalsign/ZgYsFile'),
    },
    {
        path: '/BmscFile',
        name: 'BmscFile',
        component: () => import('../epp/legalsign/BmscFile'),
    },
  {
    path: '/account/AccountManage',
    name: 'AccountManage',
    component: () => import('@/epp/account/AccountManage')
  },
    {
        path: '/enterprise/ConnectSupplier',
        name: 'ConnectSupplier',
        component: () => import('@/epp/enterprise/ConnectSupplier')
    },
    {
        path: '/message/SysMessage',
        name: 'SysMessage',
        component: () => import('@/epp/message/SysMessage')//
    },
    {
        path: '/message/SysHelp',
        name: 'SysHelp',
        component: () => import('@/epp/message/SysHelp')//
    },
    {
        path: '/message/SysHelpIndex',
        name: 'SysHelpIndex',
        component: () => import('@/epp/message/SysHelpIndex')//
    },
  {
    path: '/message/SysHelpIndex2',
    name: 'SysHelpIndex2',
    component: () => import('@/epp/message/SysHelpIndex2')//
  },
    // {
    //     path: '/enterprise/EnterpriseAuth',
    //     name: 'EnterpriseAuth',
    //     component: () => import('@/epp/enterprise/EnterpriseAuth')
    // },
    {
        path: '/enterprise/ModifyCertificateIndex',
        name: 'ModifyCertificateIndex',
        component: () => import('@/epp/enterprise/ModifyCertificateIndex')
    },
    {
        path: '/enterprise/CertificationIndex',
        name: 'CertificationIndex',
        component: () => import('@/epp/enterprise/CertificationIndex')
    },
    {
        path: '/enterprise/LegalCertificationIndex',
        name: 'LegalCertificationIndex',
        component: () => import('@/epp/enterprise/LegalCertificationIndex')
    },
    {
        path: '/enterprise/PersonCertificationIndex',
        name: 'LegalCertificationIndex',
        component: () => import('@/epp/enterprise/PersonCertificationIndex')
    },
    // {
    //     path: '/enterprise/EnterpriseAuthChange',
    //     name: 'EnterpriseAuthChange',
    //     component: () => import('@/epp/enterprise/EnterpriseAuthChange')
    // },
    // {
    //     path: '/enterprise/NatureAuthChange',
    //     name: 'NatureAuthChange',
    //     component: () => import('@/epp/enterprise/NatureAuthChange')
    // },
    {
        path: '/enterprise/Authing',
        name: 'Authing',
        component: () => import('@/epp/enterprise/CmtCertificateInfo')
    },
    {
        path: '/enterprise/NatureAuthing',
        name: 'Authing',
        component: () => import('@/epp/enterprise/NatureAuthing')
    },
    // {
    //     path: '/enterprise/NatureAuth',
    //     name: 'NatureAuth',
    //     component: () => import('@/epp/enterprise/NatureAuth')//NaturalAuth.vue
    // },
  //模拟自由竞价
    {
        path: '/compete/SimulationCompete',
        name: 'SimulationCompete',
        component: () => import('@/epp/compete/NewSimulationCompete')
    },
  //模拟单轮竞价
  {
    path: '/compete/SimulationSingleCompete',
    name:'SimulationSingleCompete',
    component: () => import('@epp/compete/NewSimulationSingleCompete')
  },
    {
        path: '/project/LegalAnnounce',
        name: 'LegalAnnounce',
        component: () => import('@/epp/announce/LegalProjectAnnounce')
    },
    {
        path: '/LegalSignIndex',
        name: 'LegalSignIndex',
        component: () => import('../epp/legalsign/LegalSignIndex'),
    },
    {
        path: '/DemandSignIndex',
        name: 'DemandSignIndex',
        component: () => import('../epp/demandsign/DemandSignIndex'),
    },
  {
    path: '*', redirect: '/404', hidden: true
  }
]
